import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/marriage2022/banner.jpg'
import navColor from '../../assets/marriage2022/nav/color.png'
import navBg from '../../assets/marriage2022/nav/nav_bg.png'
import navBgFixed from '../../assets/marriage2022/nav/nav_bg_fixed.png'

import far1 from '../../assets/marriage2022/nav/far1.png'
import far1_active from '../../assets/marriage2022/nav/far1_active.png'
import far2 from '../../assets/marriage2022/nav/far2.png'
import far2_active from '../../assets/marriage2022/nav/far2_active.png'
import son1 from '../../assets/marriage2022/nav/son1.png'
import son1_active from '../../assets/marriage2022/nav/son1_active.png'
import son2 from '../../assets/marriage2022/nav/son2.png'
import son2_active from '../../assets/marriage2022/nav/son2_active.png'
import son3 from '../../assets/marriage2022/nav/son3.png'
import son3_active from '../../assets/marriage2022/nav/son3_active.png'
import son4 from '../../assets/marriage2022/nav/son4.png'
import son4_active from '../../assets/marriage2022/nav/son4_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(132),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(132),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(132),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${calcRemFn(29)} 0 ${calcRemFn(8)}`
  },
  topBtnBaseCss: {
    width: calcRemFn(94),
    height: calcRemFn(40),
    padding: `0 ${calcRemFn(30)}`
  },
  bottomBtnLayout: {
    justifyContent: 'center',
  },
  bottomBtnBaseCss: {
    width: calcRemFn(89),
    height: calcRemFn(24),
    padding: `0 ${calcRemFn(10)}`
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      },
    ]
  }
}

const pictureList = [
  {
    key: '1_1',
    picNum: 4,
    pid: 103410
  },
  {
    key: '2_1',
    picNum: 3,
    pid: 103422
  },
  {
    key: '2_2',
    picNum: 2,
    pid: 103422
  },
  {
    key: '2_3',
    picNum: 4,
    pid: 103422
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/marriage2022/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'blue',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

pictures.unshift({
  son: [
    require('../../assets/marriage2022/ctn/1_0_1.jpg')
  ],
})

pictures.push({
  son: [
    require('../../assets/marriage2022/ctn/2_4_1.jpg')
  ],
})

const topDiff = {
  firstSon: '_i1',
  // top1_i1: 10,
  // top1_i2: 20,
  // top2_i1: 5,
  top2_i3: 16,
}

export default {
  title: '结婚照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
}
